import { createSelector } from 'reselect';

export const getSections = (state) => state.sectionsData.sections;

export const getDefaultRoutes = (state) => state.sectionsData.defaultRoutes;

export const getSectionDepotStats = (state) => state.sectionsData.depotStats;

export const getSectionName = createSelector(
  getSections,
  (_, sectiondId) => sectiondId,
  (sections, sectiondId) =>
    (sectiondId && sections[sectiondId]?.sectionName) || ''
);
